export const growthBookFeatureFlags = {
    FORM_VALIDATION_STATUS_CHECK_ENABLED: 'form_validation_status_check_enabled',
    PLATFORM_LOGO_URL: 'logo_url',
    ALLOW_ASSESSMENT_REATTEMPT: 'cx_allow_assessment_reattempt',
    ENABLE_RESTRICT_ASSESSMENT: 'enable_restrict_assessment',
    DISPLAY_ASSESSMENT_SCORE: 'display_assessment_score',
    SHOW_ANSWER_FEEDBACK: 'show_answer_feedback',
    MIX_PANEL_ENABLED: 'mixpanel_enabled',
    DISABLED_COPY_PASTE: 'cx3_copy_paste',
    WATER_MARK_ENABLED: 'watermark_content',
    ALLOW_QUESTION_RETAKE: 'allow_question_retake',
    RECORDING_PLAYBACK_ENABLED: 'recording_playback_enabled',
    SKIP_PAYMENT: 'skip_payment',
    DRIVE_REGISTRATION_FORM: 'drive_registration_form',
    SCH_CERTIFICATION_USE_CASE: 'sch_certification_use_case',
    CANDIDATE_CONSENT_LIST: 'candidate_consent_list',
    CANDIDATE_AUTH_ENABLED: 'candidate_auth_is',
    CX_TERMS_PRIVACY_LINKS: 'cx_terms_privacy_links',
    CX_DRIVE_IN_V2: 'cx_drive_in_v2',
    FACE_AUTH_FACE_DETECTION: 'face_auth_face_detection',
    CONSENT_ENABLED: 'consent_enabled', // non existing flag
    CONSENT_ALWAYS_REQUIRED: 'consent_always_required', // non existing flag
    EXIT_URL: 'exit_url',
    TENANT_CONSENT_FORM_ENABLE: 'candidate_tenant_consent_form_enable',
    ENABLED_IR_EXTRA_QUERY_PARAMS: 'enabled_ir_extra_query_params',
    SLOT_USER_CANCEL_LINK_DISABLE: 'slot_user_cancel_link_disable',
    SLOT_USER_RESCHEDULE_LINK_DISABLE: 'slot_user_reschedule_link_disable',
    SLOT_RESCHEDULE_CUTOFF_TIME: 'slot_reschedule_cutoff_time',
    SLOT_CANCEL_CUTOFF_TIME: 'slot_cancel_cutoff_time',
    CANDIDATE_FACE_AUTH_REDIRECTION: 'candidate_face_auth_redirection',
    CX_CONFIRM_SLOT_ON_SLOT_SELECTION: 'cx_confirm_slot_on_slot_selection',
    POST_ASSESSMENT_FORM: 'post_assessment_form',
    POST_INTERVIEW_FORM: 'post_interview_form',
    CX_PAYMENT_FAILED_RESCHEDULE_DISABLED: 'cx_payment_failed_reschedule_disabled',
    CX_CHAT_BOT_ENABLED: 'cx_chat_bot_enabled',
    CX_PAYMENT_RETRY_ENABLED: 'cx_payment_retry_enabled',
    CX_HELP_CENTER_ENABLED: 'cx_help_center_enabled',
    CX_PROVIEW_TOKEN: 'cx-proview-token',
    CX_WALKTHROUGH_MCQ_WITHOUT_SKIP: 'cx_walkthrough_mcq_without_skip',
    CX_WALKTHROUGH_MCQ_WITH_SKIP: 'cx_walkthrough_mcq_with_skip',
    CX_SECURE_BROWSER_CONFIG: 'cx_secure_browser_config',
    CX_IVY_REPORT_ENABLE_VISUAL_CUES: 'cx_ivy_report_enable_visual_cues',
    CX_REPORT_SCORING_ENABLED: 'cx_report_scoring_enabled',
    CX_REPORT_QUESTION_ENABLE: 'cx_report_question_enable',
    CX_SCHEDULING_CERTIFICATION_LINK_BLOCK: 'cx_scheduling_certification_link_block',
    CX_USE_ATX_BOOK_EXAM_SLOT_MUTATION_ENABLED: 'cx_use_atx_book_exam_slot_mutation_enabled',
    CX_INRTERVIEW_AVAILABILITY_SHARING_ENABLED: 'cx_interview_availability_sharing_enabled',
    CX_ASSESSMENT_ASYNC_LOBBY: 'cx_assessment_async_lobby',
};
